import React from 'react';

const MenuFooterPaymentsListItem = ({ icon, type }) => (
  <div className="payment-item">
    <img alt={type} className="payment-item__img" src={icon} />
  </div>
);

export default MenuFooterPaymentsListItem;
